module.exports = __webpack_public_path__ + "img/pdf-preview.5bc4479.png";